import * as React from 'react';
import { CustomButton, ButtonType, Modal, ModalSize, ModalBody, ModalFooter, Textarea, HiddenInput, CustomSubmitButton, Form, TextInput } from "soprasteria-ui-library";
import { IRiskPotReportNote } from '../../../models/IRiskPotReport';
import { useAuth } from '../../../App';
import { RiskPotReportNoteApi } from '../../../api/RiskPotReportNoteApi';
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface IRiskPotReportNotesModal {
    riskPotReportNote?: IRiskPotReportNote;
    riskPotReportId: number;
    setSelectedNote: React.Dispatch<React.SetStateAction<IRiskPotReportNote | undefined>>;
    changeSuccessMessage: (message: string) => void;
    getRiskPotReport: () => void;
    renderForm: boolean;
    onClose: () => void;
}

export const RiskPotReportNotesModal: React.FunctionComponent<IRiskPotReportNotesModal> = ({ riskPotReportId, riskPotReportNote, setSelectedNote, changeSuccessMessage, getRiskPotReport, renderForm, onClose }) => {
    const auth = useAuth();
    const api = new RiskPotReportNoteApi(auth)
    const [isSavingNote, setIsSavingNote] = React.useState<boolean>(false);

    const onSubmit = (data: IRiskPotReportNote) => {
        setIsSavingNote(true);
        api.saveRiskPotReportNote(data, () => {
            changeSuccessMessage("Noteringen har sparats");
            setSelectedNote(undefined);
            getRiskPotReport();
            document.getElementById("close-create-risk-pot-report-note")?.click();
        }, undefined, () => setIsSavingNote(false));
    }

    const onFormClose = () => {
        setSelectedNote(undefined);
        onClose();
    }

    return (
        <Modal id="create-risk-pot-report-note" modalSize={ModalSize.large} header={riskPotReportNote ? "Notering" : "Skapa notering"}>
            <Form onSubmit={onSubmit}>
                {
                    renderForm ?
                        <>
                            <ModalBody>
                                <HiddenInput name="riskPotReportNoteId" value={riskPotReportNote ? riskPotReportNote.riskPotReportNoteId.toString() : "0"} />
                                <HiddenInput name="riskPotReportId" value={riskPotReportId.toString()} />
                                <Textarea name="text" label="Notering" defaultValue={riskPotReportNote ? riskPotReportNote.text : ""} required inlineLabel rows={7} maxLength={500} />
                                {
                                    riskPotReportNote ?
                                        <>
                                            <TextInput label="Skapad av" name="" defaultValue={riskPotReportNote.dentist} readonly inlineLabel />
                                            <TextInput label="Skapad datum" name="" defaultValue={dateTimeToDateString(riskPotReportNote.createdDate)} readonly inlineLabel />
                                        </>
                                        : null
                                }
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText={riskPotReportNote !== undefined ? "Avbryt" : "Stäng"} data-dismiss="modal" id="close-create-risk-pot-report-note" onClick={() => onFormClose()} />
                                {
                                    <CustomSubmitButton isLoading={isSavingNote}>Spara notering</CustomSubmitButton>
                                }
                            </ModalFooter>
                        </>
                        : null
                }

            </Form>
        </Modal>
    )
}